<template>
  <div>
    <div
      v-if="showStepsProgress"
      class="package-details__progress-wrapper"
    >
      <div class="row">
        <div class="col-xs-3 col-md-2">
          <radial-progress-bar
            :diameter="85"
            :completed-steps="letterJacketSteps.CurrentStep"
            :total-steps="letterJacketSteps.NumberSteps"
            :stroke-width="7"
            start-color="#5FB630"
            stop-color="#5FB630"
            inner-stroke-color="#D8D8D8"
            stroke-linecap="flat"
          >
            <div class="package-details__progress-legend">Step<br>{{ letterJacketSteps.CurrentStep }}/{{ letterJacketSteps.NumberSteps }}</div>
          </radial-progress-bar>
        </div>
        <div
          class="col-xs-9 col-md-10"
        >
          <h1 class="gen-config__title package-details__title--with-progress">
            {{ model.Package.CatalogPackage.RetailName }}
        </h1></div>
      </div>
    </div>

    <div v-if="!showStepsProgress">
      <h1 class="gen-config__title text-center">
        {{ model.Package.CatalogPackage.RetailName }}
      </h1>
    </div>

    <div
      v-if="model.Package.CatalogPackage.RetailDescription.length > 0"
      class="gen-config__heading-retail-description"
    >
      <vue-markdown>{{ model.Package.CatalogPackage.RetailDescription }}</vue-markdown>
    </div>

    <div
      v-if="showAdditionalInfo"
      :data-contentful-text="model.Package.CatalogPackage.CmsPackageAdditionalInformation.Id"
      class="gen-config__additional-info"
    >
      <h2
        v-if="!stringIsNullOrEmpty(model.Package.CatalogPackage.CmsPackageAdditionalInformation.Title)"
        class="gen-config__additional-info-title"
      >
        {{ model.Package.CatalogPackage.CmsPackageAdditionalInformation.Title }}
      </h2>

      <div
        v-if="model.Package.CatalogPackage.CmsPackageAdditionalInformation.Image != null"
        class="gen-config__additional-info-image"
      >
        <div class="row row--mb-20">
          <div class="col-xs-12 col-md-8 col-md-offset-2">
            <img
              :src="model.Package.CatalogPackage.CmsPackageAdditionalInformation.Image.File.Url"
              :alt="model.Package.CatalogPackage.CmsPackageAdditionalInformation.Image.Description"
              class="responsive-img"
            >
          </div>
        </div>
      </div>

      <div
        v-if="!stringIsNullOrEmpty(model.Package.CatalogPackage.CmsPackageAdditionalInformation.Text)"
        class="gen-config__additional-info-text"
      >
        <vue-markdown>{{ model.Package.CatalogPackage.CmsPackageAdditionalInformation.Text }}</vue-markdown>
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from '@Shared/plugins/vue-radial-progress/src/RadialProgressBar'
import VueMarkdown from 'vue-markdown'

export default {
  name: 'PackageDetails',
  components: {
    RadialProgressBar,
    VueMarkdown
  },
  computed: {
    model () {
      return this.$store.state.catalogPageCommon.packageDetailsViewModel
    },
    letterJacketSteps () {
      return this.$store.state.letterJackets.letterJacketContent.steps
    },
    showAdditionalInfo () {
      const result = (
        !this.stringIsNullOrEmpty(this.model.Package.CatalogPackage.CmsPackageAdditionalInformationId) &&
        (
          !this.stringIsNullOrEmpty(this.model.Package.CatalogPackage.CmsPackageAdditionalInformation.Text) ||
          this.model.Package.CatalogPackage.CmsPackageAdditionalInformation.Image !== null
        )
      )

      return result
    },
    showStepsProgress () {
      return this.letterJacketSteps !== null && this.letterJacketSteps.NumberSteps > 1
    }
  },
  methods: {
    stringIsNullOrEmpty (string) {
      return string === null || string.length === 0
    }
  }
}
</script>

<style lang="scss" scoped>
.package-details {
  &__progress {
    &-wrapper {
      margin-bottom: 20px;
    }

    &-legend {
      text-align: center;
      text-transform: uppercase;
      font-size: 16px;
      font-weight: 600;
      line-height: 18px;
    }
  }

  &__title {
    &--with-progress {
      margin-top: 24px;
    }
  }
}

.gen-config__title {
  font-size: 35px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageDetails.vue